import React from 'react';
import { BlurBackgroundDivFixed } from 'crono-fe-common/components/Layout/BlurBackgroundDiv';
import { StrategySelectorModalWrapper } from './style';
import StrategySelector from '../../pages/lists/contactTable/strategySelector';
import { Strategy } from 'crono-fe-common/types/strategy';

interface IProps {
  close: () => void;
  returnSelectedStrategy: (strategy: Strategy) => void;
}

const StrategySelectorModal: React.FC<IProps> = ({
  close,
  returnSelectedStrategy,
}) => {
  return (
    <BlurBackgroundDivFixed onClick={close}>
      <StrategySelectorModalWrapper>
        <div
          className="strategy-selector-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <StrategySelector
            style={{ width: '100%', maxHeight: '100%' }}
            returnSelectedStrategy={returnSelectedStrategy}
            enableStartDate={false}
          />
        </div>
      </StrategySelectorModalWrapper>
    </BlurBackgroundDivFixed>
  );
};

export default StrategySelectorModal;
